import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import GamesList from './GamesList'
import StatsNavBar from './StatsNavBar'
import SeasonTeamPlayersPage from '../PlayersPage/SeasonTeamPlayersPage'

const StatsNavigationPage = ({ children, resolvedSeasonTeamId, resolvedTeamId, resolvedSeasonId, orgId }) => {
  const [currentTab, setCurrentTab] = useState('stats')
  const previousTab = useRef(currentTab)

  // Handle tab changes and update URL hash
  const handleTabChange = (tab) => {
    previousTab.current = currentTab
    setCurrentTab(tab)
    window.history.pushState({ tab }, '', `#${tab}`)
  }

  // Initialize tab state from URL hash or default to 'stats'
  useEffect(() => {
    const hash = window.location.hash.replace('#', '')
    const initialTab = hash || 'stats' // Default to 'stats' if no hash is present
    setCurrentTab(initialTab)
  }, [])

  // Sync tab state with URL hash on popstate events
  useEffect(() => {
    const handlePopState = (event) => {
      if (event.state && event.state.tab) {
        setCurrentTab(event.state.tab)
      } else {
        setCurrentTab('stats')
      }
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])

  const renderContent = () => {
    switch (currentTab) {
      case 'games':
        return <GamesList orgId={orgId} resolvedTeamId={resolvedTeamId} resolvedSeasonId={resolvedSeasonId} />
      case 'players':
        return <SeasonTeamPlayersPage seasonTeamId={resolvedSeasonTeamId} />
      default:
        return children
    }
  }

  return (
    <div>
      <StatsNavBar currentTab={currentTab} setCurrentTab={handleTabChange} />
      {renderContent()}
    </div>
  )
}

StatsNavigationPage.propTypes = {
  children: PropTypes.node,
  resolvedSeasonTeamId: PropTypes.string,
  resolvedTeamId: PropTypes.string,
  resolvedSeasonId: PropTypes.string,
  orgId: PropTypes.string,
}

export default StatsNavigationPage
